import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Navegacao } from '../../commons/navegacao';
import { Location } from '@angular/common';
import { DesignSystemSigmaService } from "app/services/design-system-sigma.service";

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private navegacao: Navegacao,
    private dssService: DesignSystemSigmaService,
    private location: Location,
    private router: Router,


  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      // atrasa o direcionamento para a realizar a verificação de rotas no caso
      // da configuração do SIGMA
      if (this.location.path().match('verify-redirect')) return
      if (this.isDssLayout())
        this.navegacao.run(["pages/error/dss"]);
      else
        this.navegacao.run(['/pages/login'], this.route, { return: state.url });
      return false;
    }
  }

  isDssLayout(): boolean {
    return this.dssService.isDssLayout();
  }
}
